module.exports = __webpack_public_path__ + "4c912391555eb86deb23693b593435c9.png";